export enum DropdownSize {
  SMALL = 'small',
  DEFAULT = 'default'
}